// Mitarbeiter-Auswahl fürs Zuweisen von Wiedervorlagen.
//
// Liest die aktiven App-Nutzer über `list_callcenter_agents` (Migration 1076).
// Bewusst NICHT `list_users`: das ist Admin-Werkzeug und fliegt für normale
// Agents mit „permission denied" raus — genau die brauchen die Auswahl aber
// beim Anlegen einer Wiedervorlage.
//
// Der Anzeigename kommt schon fertig aus der Datenbank (derselbe Resolver wie
// in allen Auswertungs-Views), `anzeigeName` greift nur, falls er dort fehlt.
import { supabase } from './supabase';
import { useCachedQuery } from './useCachedQuery';
import { anzeigeName } from './anzeigeName';

export interface MitarbeiterOption {
  id: string;
  display_name: string | null;
  email: string | null;
}

/** Aktive Mitarbeiter mit App-Zugang, alphabetisch. Lange gecacht — die
 *  Liste ändert sich höchstens bei einer Einladung. */
export function useMitarbeiter(): {
  mitarbeiter: MitarbeiterOption[];
  error: string | null;
} {
  const { data = [], error } = useCachedQuery<MitarbeiterOption[]>(
    'mitarbeiter:aktiv',
    async () => {
      const { data, error } = await supabase.rpc('list_callcenter_agents');
      if (error) throw new Error(error.message);
      return (data as MitarbeiterOption[]) ?? [];
    },
    { staleMs: 10 * 60_000 },
  );
  return { mitarbeiter: data, error };
}

/** Name eines Mitarbeiters aus der Liste — für Bestätigungstexte. */
export function mitarbeiterName(
  liste: MitarbeiterOption[],
  id: string | null | undefined,
): string | null {
  if (!id) return null;
  const m = liste.find((x) => x.id === id);
  if (!m) return null;
  return m.display_name?.trim() || anzeigeName(null, null, m.email);
}
